import '@/assets/style/main.scss';
import App from '@/App.vue';
import { createApp } from 'vue';
import letterCapitalDirective from '@/directives/letterCapitalDirective';
import { registerPlugins } from '@/plugins';

const app = createApp(App);
registerPlugins(app);
app
  .directive('letter-capital', letterCapitalDirective)
  .mount('#app');
